// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDependentUpdateDto
 */
export interface IDependentUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IDependentUpdateDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentUpdateDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentUpdateDto
     */
    last_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IDependentUpdateDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IDependentUpdateDto
     */
    relationship_type?: IDependentUpdateDtoRelationshipTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDependentUpdateDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IDependentUpdateDto interface.
 */
export function instanceOfIDependentUpdateDto(value: object): value is IDependentUpdateDto {
    return true;
}

export function IDependentUpdateDtoFromJSON(json: any): IDependentUpdateDto {
    return IDependentUpdateDtoFromJSONTyped(json, false);
}

export function IDependentUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
    };
}

export function IDependentUpdateDtoToJSON(json: any): IDependentUpdateDto {
    return IDependentUpdateDtoToJSONTyped(json, false);
}

export function IDependentUpdateDtoToJSONTyped(value?: IDependentUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ssn': value['ssn'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'relationship_type': value['relationship_type'],
    };
}

